var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHero(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 41,
    viewBox: "0 0 122 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3700_5269)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.977 17.5344H45.9541V9.6875H40.2344V30.9895H45.9541V22.4558H54.977V30.9895H60.6852V9.6875H54.977V17.5344Z",
    fill: "#EE2326"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9198 17.8398C69.3991 14.9641 70.9603 13.462 73.4915 13.462C76.0515 13.462 77.7906 15.233 77.8739 17.8398H68.9198ZM73.5231 9.125C67.2294 9.125 63.0078 13.5496 63.0078 20.1866C63.0078 27.0895 67.1806 31.4761 73.7039 31.4761C78.9156 31.4761 82.4887 29.0417 83.8289 24.4329H77.6558C77.0961 26.1163 75.7903 26.9609 73.8273 26.9609C70.8771 26.9609 69.1035 25.1811 68.9542 22.0862H83.8289C83.8289 21.338 83.8719 21.075 83.8719 20.7185C83.8719 13.5496 79.877 9.125 73.5231 9.125",
    fill: "#EE2326"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5938 9.49961C91.5705 9.90876 86.3789 11.4986 86.3789 19.5646V30.9828H92.1646V21.5519C92.1646 18.0596 92.641 16.42 94.0702 15.3621C94.9455 14.649 96.2112 14.2545 97.6805 14.2545C98.289 14.2545 98.5501 14.3013 99.2475 14.4298V9.59606C99.2475 9.59606 96.9401 8.83329 93.5938 9.49961Z",
    fill: "#EE2326"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.69 27.0378C107.642 27.0378 105.863 24.5187 105.863 20.3132C105.863 16.0639 107.605 13.5857 110.69 13.5857C113.729 13.5857 115.471 16.0201 115.471 20.2694C115.471 24.5654 113.729 27.0378 110.69 27.0378ZM110.69 9.11719C104.204 9.11999 100.031 13.498 100.031 20.3132C100.031 27.0817 104.204 31.4683 110.69 31.4683C117.116 31.4683 121.294 27.0817 121.294 20.3132C121.294 13.498 117.116 9.11719 110.69 9.11719Z",
    fill: "#EE2326"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5705 7.06641L15.625 0.335938V19.5074L24.5705 13.1919V7.06641Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5705 34.4812V21.3125L15.625 27.8618L24.5705 34.4812Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00390625 33.7114L8.95224 40.3338V12.918L0.00390625 6.1875V33.7114Z",
    fill: "#EE2326"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3700_5269"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 121.29,
    height: 40,
    fill: "white",
    transform: "translate(0.00390625 0.335938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHero);
export default __webpack_public_path__ + "static/media/hero.49fd684d14514ca2fe333774e723a33a.svg";
export { ForwardRef as ReactComponent };